/**
 * Customer-facing stock line for a store-scoped product.
 * @param {object} product
 * @param {{ storeName?: string }} [opts]
 */
export function stockSummary(product, opts = {}) {
  const branch = opts.storeName?.trim() || 'This branch';
  if (product?.isServiceItem) {
    return { text: `Available at ${branch} (service)`, tone: 'neutral' };
  }
  const q = Number(product?.quantityOnHand);
  const hasQty = !Number.isNaN(q);
  if (product?.inStock === false || (hasQty && q <= 0)) {
    return { text: `Out of stock at ${branch}`, tone: 'out' };
  }
  if (!hasQty || q <= 0) {
    return { text: `Check availability at ${branch}`, tone: 'low' };
  }
  if (q <= 5) {
    return { text: `Only ${q} left in stock · ${branch}`, tone: 'low' };
  }
  return { text: `${q} in stock · ${branch}`, tone: 'ok' };
}

/** Higher = sort earlier when searching (in-stock / higher qty first). */
export function stockSearchScore(p) {
  if (p?.isServiceItem) return 50000;
  if (p?.inStock === false) return -1000;
  const q = Number(p?.quantityOnHand);
  if (Number.isNaN(q)) return 0;
  return q;
}
